import type { Components, CssVarsTheme } from '@mui/material/styles';
export const MuiCheckbox: Components<CssVarsTheme>['MuiCheckbox'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      padding: '10px 4px 10px 10px',
      marginRight: 4,
      color: theme.vars.palette.grey[500],
      '&.Mui-checked': {
        color: theme.vars.palette.primary.main
      },
      '&.Mui-disabled': {
        color: theme.vars.palette.text.disabled
      }
    })
  },
  defaultProps: {
    size: 'small'
  }
};
